module.exports = __webpack_public_path__ + "img/comrec.043adf18.jpeg";